import {
    EDIT_CANDIDATE_FEEDBACK_REQUEST,
    EDIT_CANDIDATE_FEEDBACK_SUCCESS,
    EDIT_CANDIDATE_FEEDBACK_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editCandidateFeedBackReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_CANDIDATE_FEEDBACK_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_CANDIDATE_FEEDBACK_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_CANDIDATE_FEEDBACK_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editCandidateFeedBackReducer;
